import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function AdditionalInformation(props) {
  return <EyefinitySectionFields {...props} sectionName="additional_information" title="Additional Information" />
}
